import FilterContext from '@jetshop/core/components/Filters/FilterContext';
import ErrorBoundary from '@jetshop/ui/ErrorBoundary/Generic';
import PassThrough from '@jetshop/ui/ErrorBoundary/PassThrough';
import MultiSelectList from '@jetshop/ui/Select/SelectComponents/MultiSelectList';
import SelectDropdown from '@jetshop/ui/Select/SelectDropdown';
import React from 'react';
import styled from 'react-emotion';
import stripCategoryId from '@jetshop/core/components/Filters/utils/stripCategoryId';
const StyledSelectDropdown = styled(SelectDropdown)`
  margin-bottom: 0;
  > button {
    background-color: transparent;
  }
  ${({ theme }) => theme.below.sm} {
    border-top: none;
    margin: 0;
    .toggleSelect {
      border-top: 0;
    }
  }
`;
// Maps over list filters and returns a set of Downshift-powered dropdowns
const ListFilterFlyouts = ({ filters, className = '' }) => {
  const listFilters = filters.filter(
    filter => filter.__typename === 'ListFilter'
  );
  if (listFilters.length < 1) return null;
  return React.createElement(
    ErrorBoundary,
    { component: PassThrough },
    React.createElement(FilterContext.Consumer, null, filterProps =>
      listFilters.map(filter => {
        const selectedFilter = filterProps.activeFilters.listFilters.find(
          item =>
            item.id === stripCategoryId(filter.id) || item.id === filter.id
        );
        const selectedItems =
          selectedFilter && selectedFilter.values.map(val => ({ value: val }));
        const onChange = vals => {
          return filterProps.applyListFilter(filter.id, vals);
        };
        return React.createElement(StyledSelectDropdown, {
          key: filter.name,
          items: filter.items,
          title: filter.name,
          multiSelect: true,
          SelectComponent: MultiSelectList,
          selectedItems: selectedItems,
          onChange: vals => onChange(vals),
          className: className + ' ' + filter.name
        });
      })
    )
  );
};
export default ListFilterFlyouts;
//# sourceMappingURL=ListFilterFlyouts.js.map
